import * as React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

type RestApiClientProviderProps = {
  children: React.ReactNode;
};
export const RestApiClientProvider = ({
  children,
}: RestApiClientProviderProps) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 30000,
      },
    },
  });
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};
